import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch } from 'react-redux';

import { cartItemsActions } from '@src/ducks/cartItems';
import { collateralTemplateActions } from '@src/ducks/collateralTemplate';

const CartContent = (props) => {
    const dispatch = useDispatch();
    const { cartItems } = props;

    const handleOnRemove = useCallback((e, cartItem) => {
        e.preventDefault();
        dispatch(cartItemsActions.remove(cartItem.id));
        dispatch(collateralTemplateActions.request({ id: cartItem.resource_id }));
    }, [dispatch]);

    return (
        <Col className="cart-content">
            {
                cartItems.map((ci) => {
                    return (
                        <Row key={`cart-item-${ci.id}`} className="cart-item">
                            <Col xs={6} sm={6} md={6} className="pl-0">
                                <img src={ci.resource.preview_image_source} width={210} />
                            </Col>
                            <Col xs={6} sm={6} md={6} className="pl-0">
                                <h5>{ ci.resource.title }</h5>
                                <p>
                                    <a
                                        href="#"
                                        className="ml-link remove-link"
                                        onClick={(e) => handleOnRemove(e, ci)}
                                    >
                                        Remove
                                    </a>
                                </p>
                            </Col>
                        </Row>
                    );
                })
            }
        </Col>
    );
};

CartContent.propTypes = {
    cartItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default React.memo(CartContent);
